import React, { useEffect, useRef } from 'react'
import { LazyMotion, domAnimation } from 'framer-motion'
import { ThemeProvider } from './context/ThemeContext'
import { LanguageProvider } from './context/LanguageContext'
import { CMSProvider, CMSContentState } from './context/CMSContext'
import { RouterProvider, useRouter } from './router/Router'
import RestaurantPage from './pages/Restaurant/RestaurantPage'
import StoryPage from './pages/Story/StoryPage'
import LocationPage from './pages/Location/LocationPage'
import { trackPageview } from './utils/analytics'

interface AppProps {
    initialContent?: CMSContentState
    initialPath?: string
}

const RouteView: React.FC = () => {
    const { path } = useRouter()
    const isInitialLoad = useRef(true)

    useEffect(() => {
        // 초기 진입 page_view는 index.html의 gtag('config')가 전송하므로 스킵하고,
        // 이후 SPA 라우트 전환에서만 수동 page_view를 보낸다(중복 집계 방지).
        if (isInitialLoad.current) {
            isInitialLoad.current = false
            return
        }
        trackPageview(path)
    }, [path])

    if (path === '/story') return <StoryPage />
    if (path === '/location') return <LocationPage />
    return <RestaurantPage />
}

const App: React.FC<AppProps> = ({ initialContent, initialPath }) => {
    return (
        <LazyMotion features={domAnimation} strict>
            <ThemeProvider>
                <LanguageProvider>
                    <CMSProvider initialContent={initialContent}>
                        <RouterProvider initialPath={initialPath}>
                            <RouteView />
                        </RouterProvider>
                    </CMSProvider>
                </LanguageProvider>
            </ThemeProvider>
        </LazyMotion>
    )
}

export default App
